import React from 'react'
import { useInView } from '../../../../../utils/hooks/hooks/useInView'
import { isUrlExternal, Link } from '../../../../../utils/links'
import { linkListBlockNestedClasses } from '../../../../../utils/style'
import { getClassName } from '../../../../../utils/utils'
import { InviewProps, SVGIconProps } from '../../blocksState'

export type LinkBlockNested = {
  index: number
  items: LinkBlockNestedItem[]
  SVGIcon?: SVGIconProps
  inview?: InviewProps
}

type LinkBlockNestedItem = {
  url: string
  title: string
  text?: string
}

export type LinkBlockNestedStyle = Partial<{
  blockClassName: string
  inviewClassName: string
  innerClassName: string
  contentClassName: string
  listClassName: string
  itemClassName: string
  itemWithLinkClassName: string
  itemWithoutLinkClassName: string
  linkInnerClassName: string
  linkLabelClassName: string
  linkTextClassName: string
  linkIconClassName: string
  iconExternalId: string
  iconInternalId: string
}>

export const LinkBlockNestedLayout = (props: LinkBlockNested) => {
  const { inview, index, items, SVGIcon } = props
  const classes = linkListBlockNestedClasses
  const { inView, ref } = useInView(
    { threshold: 0.1 },
    (inview) => console.debug("LinkBlockNestedLayout inView:", inview),
    !inview?.triggerOnce
  )
  const inviewClassName = getClassName(classes, 'blockClassName', 'container') + ' ' + (inView ? getClassName(classes, 'inviewClassName', 'inview') : '')
  return (
    <section key={`block-${index}`} id={`io-${index}`} ref={ref} className={inviewClassName}>
      <div className={getClassName(linkListBlockNestedClasses, 'innerClassName', 'py-5')}>
        {items && items.length > 0 && (
          <div className={getClassName(linkListBlockNestedClasses, 'contentClassName', '')}>
            <ul className={getClassName(linkListBlockNestedClasses, 'listClassName', 'list-unstyled mb-0 row')}>
              {items.map((item) =>
                item.url ? (
                  <li
                    key={`link-${index}-${item.title}`}
                    className={getClassName(linkListBlockNestedClasses, 'itemClassName', 'col-md-6')}
                  >
                    <Link
                      url={item.url}
                      title={item.title}
                      className={getClassName(
                        linkListBlockNestedClasses,
                        'itemWithLinkClassName',
                        'btn btn-link w-100 text-left border-bottom rounded-0 pl-0'
                      )}
                    >
                      <LinkItemInner item={item} SVGIcon={SVGIcon} />
                    </Link>
                  </li>
                ) : (
                  <li
                    key={`link-${index}-${item.title}`}
                    className={getClassName(linkListBlockNestedClasses, 'itemClassName', 'col-md-6')}
                  >
                    <div
                      className={getClassName(
                        linkListBlockNestedClasses,
                        'itemWithoutLinkClassName',
                        'btn btn-link w-100 text-left border-bottom rounded-0 pl-0'
                      )}
                    >
                      <LinkItemInner item={item} SVGIcon={SVGIcon} />
                    </div>
                  </li>
                )
              )}
            </ul>
          </div>
        )}
      </div>
    </section>
  )
}

const LinkItemInner = (p: { item: LinkBlockNestedItem; SVGIcon?: SVGIconProps }) => (
  <>
    <div className={getClassName(
      linkListBlockNestedClasses,
      'linkInnerClassName',
      ''
    )}>
      {p.item.title && (
        <p className={getClassName(linkListBlockNestedClasses, 'linkLabelClassName', 'm-0')}>{p.item.title}</p>
      )}
      {p.item.text && (
        <p className={getClassName(linkListBlockNestedClasses, 'linkTextClassName', 'small m-0')}>{p.item.text}</p>
      )}
    </div>
    {p.SVGIcon && (
      <svg
        className={getClassName(linkListBlockNestedClasses, 'linkIconClassName', '')}
        aria-hidden="true"
        width={p.SVGIcon.width ? p.SVGIcon.width : '24px'}
        height={p.SVGIcon.height ? p.SVGIcon.height : '24px'}
      >
        <use
          xlinkHref={`${isUrlExternal(p.item.url)
              ? getClassName(linkListBlockNestedClasses, 'iconExternalId', '#icon--external')
              : getClassName(linkListBlockNestedClasses, 'iconInternalId', '#icon--chevron-right-large')
            }`}
        />
      </svg>
    )}
  </>
)
